import { Trophy } from 'lucide-react';
import { useBolaoHistorico } from '../../hooks/useBolaoHistorico';

export interface BolaoResultadoProps {
  telaId: string;
  fixtureId: number;
  placarCasa: number;
  placarVisitante: number;
  compacto?: boolean;
}

export function BolaoResultadoHistorico({
  telaId,
  fixtureId,
  placarCasa,
  placarVisitante,
  compacto = false,
}: BolaoResultadoProps) {
  const { palpites, vencedores, loading, erro } = useBolaoHistorico(
    telaId,
    fixtureId,
    placarCasa,
    placarVisitante,
  );
  const total = palpites.length;

  if (loading) {
    return <p className="text-white/40 text-xs py-2">Carregando bolão...</p>;
  }

  if (erro) {
    return <p className="text-white/40 text-xs py-2">Não foi possível carregar o bolão.</p>;
  }

  return (
    <div className={`rounded-xl bg-amber-500/5 border border-amber-500/15 ${compacto ? 'p-2.5' : 'p-3'} space-y-2`}>
      <p className="text-[11px] font-medium text-amber-400/80">
        Bolão · placar final {placarCasa} × {placarVisitante}
      </p>
      {total === 0 ? (
        <p className="text-white/40 text-xs">Nenhum palpite neste jogo.</p>
      ) : vencedores.length > 0 ? (
        <>
          <p className="text-emerald-400 text-xs font-bold flex items-center gap-1.5">
            <Trophy size={14} className="shrink-0" />
            {vencedores.length === 1 ? 'Vencedor' : 'Vencedores'}
          </p>
          <div className="flex flex-wrap gap-2">
            {vencedores.map((v) => (
              <span
                key={v.id}
                className="px-3 py-1.5 rounded-lg bg-amber-500/15 border border-amber-500/25 text-amber-300 text-xs font-bold"
              >
                {v.identificacao}
              </span>
            ))}
          </div>
          {!compacto && (
            <p className="text-white/35 text-[10px]">{total} palpites no total</p>
          )}
        </>
      ) : (
        <p className="text-white/50 text-xs">Ninguém acertou o placar ({total} palpites).</p>
      )}
    </div>
  );
}
